module.exports = __webpack_public_path__ + "static/logo-csg-64b6b5392cd039d66c1368755f31ebe0.png";